<template>
  <el-dialog
    :visible.sync="showModal"
    :center="true"
    :show-close="true"
    :append-to-body="true"
    :modal="!isMobileWidth"
    class="premium-upsell"
    custom-class="upsell-modal"
    @closed="closeModal">
    <div
      class="premium-upsell-modal"
      data-test="premiummodel">
      <img
        src="../assets/images/upsell.png"
        class="top-image">
      <h2 class="main-title">Get started with Premium</h2>
      <el-row
        :gutter="12"
        class="top-content">
        <el-col
          :sm="{span: 8}"
          :xs="{span: 24}">
          <div class="yellow-circle"><span>1</span></div>
          <h4>Luminary Originals</h4>
          <p>40+ shows we're launching this year from top creators you'll only hear with Luminary Premium for {{ localPricing.price | amountFilter(localPricing.currency) }} {{ localPricing.price | taxFilter(localPricing.currency) }}.</p>
        </el-col>
        <el-col
          :sm="{span: 8}"
          :xs="{span: 24}">
          <div class="yellow-circle"><span>2</span></div>
          <h4>Uninterrupted Listening</h4>
          <p>Ad-free Luminary Originals.</p>
        </el-col>
        <el-col
          :sm="{span: 8}"
          :xs="{span: 24}">
          <div class="yellow-circle"><span>3</span></div>
          <h4>Cancel Anytime</h4>
          <p>Take a break from Premium anytime.</p>
        </el-col>
      </el-row>
      <el-row
        class="premium-info">
        <div class="btn-group">
          <button
            class="el-button btn-white-transparent"
            data-test="btn-skipmodal"
            @click="closeModal">Skip</button>
          <button
            class="el-button el-button--primary"
            data-test="btn-freemonth"
            @click="$router.push('/premium-buy')">Try
            <span
              v-if="promoMeta.trialPeriod > 1"
              class="line-through">1 month</span> {{ promoMeta.formattedTrialPeriod }} free</button>
        </div>
        <div class="price-info">
          <span>
            {{ defaultPrice.price | amountFilter(defaultPrice.currency) }} {{ defaultPrice.price | taxFilter(defaultPrice.currency) }}.
            <router-link
              color="primary"
              to="/termsfreetrial"
              target="_blank"
              data-test="link-terms"
            >
              Terms apply
            </router-link>
          </span>
        </div>
      </el-row>
    </div>
  </el-dialog>
</template>
<script>

export default {
  name: 'PremiumUpsellModal',
  props: {
    show_modal: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      showModal: this.show_modal,
      defaultPrice: this.$store.getters.pricing,
    };
  },
  computed: {
    isSubscribed() {
      return this.$store.getters.user.is_subscribed;
    },
    usersCountryPricing() {
      return this.$store.getters.pricing;
    },
    isMobileWidth() {
      return (window && window.innerWidth) <= this.screenSize.sm;
    },
  },
  watch: {
    show_modal(newVal) {
      this.showModal = newVal;
    },
    usersCountryPricing(newVal) {
      if (newVal) {
        this.defaultPrice = newVal;
      }
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/variables.scss";
.upsell-modal {
  overflow-x: hidden !important;
  width: 58% !important;
  background: $black1 !important;
  top: 50%;
  transform: translateY(-50%);
  margin-top: 0px !important;
  .el-dialog__headerbtn {
    top: 5px;
    right: 10px;
    i {
      color: #fff;
      font-weight: bold;
    }
  }
  .top-image {
    margin: 0 auto;
    display: block;
    padding: 11px 0 45px 0;
  }
  .el-dialog__header{
    padding: 0px;
  }
  .el-dialog__body{
    padding: 0px;
  }
  .premium-upsell-modal {
    .top-image {
      margin-top: 15px;
    }
    .main-title {
      font-size: 50px;
      color: #fff;
      text-align: center;
      font-family: "ITC Clearface";
      line-height: 50px;
      margin: 0 0 50px 0;
    }
    .yellow-circle {
      width: 33px;
      height: 33px;
      border-radius: 50%;
      background-color: $brand;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        color: $black;
        font-family: "ITC Clearface";
        font-size: 24px;
      }
    }
    .top-content {
      padding: 0 50px;
      .el-col {
        h4 {
          margin: 15px 0;
          color: #fff;
          font-size: 24px;
          text-align: center;
          letter-spacing: -0.21px;
          font-family: "ITC Clearface";
          font-weight: 400;
        }
        p {
          color: #fff;
          font-size: 14px;
          text-align: center;
        }
      }
    }
    .premium-info {
      margin-top: 40px;
      text-align: center;
      .btn-group {
        .btn-white-transparent {
          border: 1px solid #fff;
          background: transparent;
          color: #fff;
          width: 200px;
          height: 50px;
          margin-top: 10px;
          transition: .3s all ease-in-out;
          &:hover {
            background: #fff;
            color: $black;
          }
        }
        .el-button--primary {
          margin-top: 10px;
          height: 50px;
        }
      }
      .price-info {
        margin: 16px 0 40px 0;
        span {
          color: $xlight-gray;
        }
        a {
          color: $xlight-gray;
          text-decoration: underline;
        }
      }
    }
  }
}
@media (max-width: 1024px) {
  .upsell-modal {
    width: 70% !important;
    .premium-upsell-modal {
      .top-content {
        padding: 0 15px;
      }
    }
  }
}
@media (max-width: 768px) {
  .upsell-modal {
    width: 100% !important;
    height: 100vh !important;
    margin: 0 0 !important;
    .premium-upsell-modal {
      .main-title {
        font-size: 42px;
      }
      .top-content {
        .el-col-xs-24 {
          width: 33.33%;
        }
      }
    }
  }
}
@media (max-width: 576px) {
  .upsell-modal {
    width: 100% !important;
    height: 100vh !important;
    margin: 0 0 !important;
    .premium-upsell-modal {
      padding: 0 15px;
      .top-image {
        padding-bottom: 15px;
        margin-left: -15px;
      }
      .main-title {
        font-size: 36px;
        margin-bottom: 25px;
        line-height: 36px;
      }
      .yellow-circle {
        display: none;
      }
      .top-content {
        .el-col-xs-24 {
          width: 100%;
        }
        .el-col {
          h4 {
            font-size: 20px;
            margin-bottom: 8px;
          }
        }
      }
      .premium-info {
        margin-top: 16px;
        .btn-group {
          display: flex;
          .el-button {
            flex: 1 1 0;
            margin: 0px 8px;
          }
          /* .btn-white-transparent {
            max-width: 123px;
            width: 40%;
          }
          .el-button--primary {
            max-width: 198px;
            width: 60%;
          } */
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/PremiumUpsellModal.vue